var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full"},[_c('wrapper-widget-table',{ref:"widgetTable",attrs:{"reportData":_vm.reportData},on:{"updateReportData":_vm.updateReportData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }